module.exports = __webpack_public_path__ + "static/08-375ba540cb677923454773d15d0fcbb1.jpeg";